import 'bootstrap/dist/css/bootstrap.min.css';
import './../index.css';
import {adorLogo} from "assets/images";
import {Card } from 'react-bootstrap';
import { useNavigate } from 'react-router';
import SingleLoanServices from 'services/services/BankServices';
import { Col, Layout, Row, Form, Input,message  } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import { convertToObjectKeyString } from "Utils/Common";
import fi_translation from 'locale/fi';
import Cookies from 'universal-cookie';

function ModeratorBankLogin() {
    const navigate = useNavigate();
    const cookies = new Cookies();
    const Locale: any = {
        fi: fi_translation,
    };
    cookies.remove("bank_form_tender_id", { path: 'pankki/' });
    cookies.remove("bank_form_tender_id", { path: '/' });
    cookies.remove("access_token", { path: 'pankki/' });

    const TranslateStringFin = (string:any) => {
        let key:any = convertToObjectKeyString(string);
        let value = Locale['fi'][key];
        return (value===key) ? string : value;
    };

    const submitLogin = (formData:any) =>{
        SingleLoanServices
        .bankOfferAccess(formData)
        .then((response: any) => {
            if (response?.data?.code === 200) {
                cookies.set("bank_form_tender_id", response?.data?.data?.tender_id, { path: 'pankki/' });
                cookies.set("access_token", response?.data?.data?.token, { path: 'pankki/' });
                navigate("/pankki/"+response?.data?.data?.tender_id, { replace: true })     
                message.success(TranslateStringFin("login_successfully"));
            }else{
                message.error(TranslateStringFin("invalid_code"));
            }
        })
        .catch((err: any) => {
            console.log(err)
        });
    }

    return (
        <>
            <Layout>
                <Content className="body-login-background my-auto text-white">
                    <div>
                        <Row className='w-100'>
                            <Col xs={24}>
                                <div >
                                    <Form
                                        name="basic"
                                        wrapperCol={{ span: 24 }}
                                        onFinish={submitLogin}
                                    >
                                        <img src={adorLogo} alt="Ador Logo" className="text-center mb-5" style={{'width':'200px'}}/>
                                        <Card className="bg-light rounded-0 text-dark bg-white card-primary-top px-3" >
                                            <Card.Body>
                                                <h1 className="fw-300 fs-3 px-5 py-3">{TranslateStringFin('verify_to_your_account')}</h1>
                                                <Form.Item
                                                    name="secure_code"
                                                    rules={[{ required: true,message: TranslateStringFin('code_is_required')}]}
                                                    className="text-left"
                                                >
                                                    <Input placeholder={TranslateStringFin('security_code')} />
                                                </Form.Item>
                                                <button type="submit" className="btn btn-sm btn-primary w-100 mt-2 rounded-0 mb-5">{TranslateStringFin('verify')}</button>
                                            </Card.Body>
                                        </Card>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Content>
            </Layout>
        </>
    );
}

export default ModeratorBankLogin;